import { IUser } from "../user";

export interface ITitleItems {
  title: string;
  tag?: string;
}
export interface IProgressInvestmentItems {
  capital: string | number;
  progressValue: string | number;
}
export interface ISummaryItem {
  successful_projects: string | number;
  volume_of_investment: string | number;
  investor: string | number;
}
export enum AddPropertyStepTypes {
  BasicPlanInfo = 0,
  CapitalizationDetails = 1,
  AdditionalInfo = 2,
  ExecutiveCalender = 3,
}
export interface IProperty {
  title: string;
  symbol?: string;
  symbol_fa?: string;
  description?: string;
  background?: string;
  average_profit?: string | null;
  farabourse_reference?: string | null;
  owner_name?: string;
  owner_id?: number | null;
  excerpt?: string;
  monthly_wage?: number;
  yearly_wage?: number;
  period_months?: number | null;
  is_guaranteed?: string;
  has_invested?: boolean;
  collateral_type?: string;
  min_investment_quantity?: number;
  max_investment_quantity?: number;
  investment_ratio?: number;
  risk_statement?: string;
  media?: any[];
  finance_statement?: string;
  investors_count?: string | number | null;
  company_statement?: string;
  required_investment_quantity?: string | null;
  market_statement?: string;
  total_investment_quantity?: string;
  total_investment_percent?: number;
  advantage_statement?: string;
  status?: string;
  total_shares?: number;
  meta?: any[];
  owner?: IUser;
  id: string;
  created_at: string;
  updated_at: string;
  expires_at: string;
  sold_shares: number;
}
